/**
 * @fileoverview Header Component
 * @description Application header with Alaska Airlines styling
 * @module components/layout/Header
 */

import React from 'react';
import { Menu } from 'lucide-react';
import { UserProfile } from '@/components/auth';
import { NotificationBell } from '@/components/common/NotificationBell';
import './Header.css';

/**
 * Header component for the application
 * @param {Object} props - Component props
 * @param {Function} props.onMenuClick - Handler for mobile menu button
 * @param {string} props.title - Page title
 * @returns {JSX.Element} Header component
 */
export const Header = ({ onMenuClick, title = '' }) => {
  return (
    <header className="header">
      <div className="header-left">
        <button 
          className="mobile-menu-button"
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <Menu size={24} />
        </button>
        {title && <h1 className="header-title" title={title}>{title}</h1>}
      </div>

      <div className="header-right">
        <NotificationBell />
        <UserProfile />
      </div>
    </header>
  );
};

export default Header;
